"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var react_1 = require("react");

var util_1 = require("../util");

var renderProp_1 = tslib_1.__importDefault(require("../util/renderProp"));

var State = function (_super) {
  tslib_1.__extends(State, _super);

  function State(props, context) {
    var _this = _super.call(this, props, context) || this;

    _this.state = props.init || {};
    _this.setState = _this.setState.bind(_this);
    return _this;
  }

  State.prototype.componentDidMount = function () {
    this.props.onMount(this.state);
  };

  State.prototype.componentWillUnmount = function () {
    this.props.onUnmount(this.state);
  };

  State.prototype.render = function () {
    return renderProp_1.default(this.props, this.state, this.setState);
  };

  State.defaultProps = {
    onChange: util_1.noop,
    onMount: util_1.noop,
    onUnmount: util_1.noop
  };
  return State;
}(react_1.Component);

exports.State = State;

exports.withState = function (Comp, name, init) {
  if (name === void 0) {
    name = 'state';
  }

  if (init === void 0) {
    init = {};
  }

  return function (props) {
    return util_1.h(State, {
      init: init,
      render: function render(state, set) {
        var _a;

        return util_1.h(Comp, name ? tslib_1.__assign((_a = {}, _a[name] = tslib_1.__assign({}, state, {
          set: set
        }), _a), props) : tslib_1.__assign({}, state, {
          set: set
        }, props));
      }
    });
  };
};